import React from "react";
import Heading from "./Heading";
import { deals } from "./dealsData";
function Deals() {
  return (
    <>
      <a href="#" id="deals"></a>
      <div className="w-full p-4 h-fit font-fancy">
        <Heading heading="Deals" />
        {deals.map((deal) => {
          return (
            <React.Fragment key={deals.id}>
              <div className="p-4 my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
                <h3 className="text-base font-extrabold">Deal {deal.dealNo}</h3>
                <p className="py-2 text-base">{deal.description}</p>
                <div className="inline-block">
                  <p className="px-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                    {deal.price}
                  </p>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}

export default Deals;
